import { FaGithub, FaReact, FaCss3, FaHtml5, FaSass } from "react-icons/fa";
import { DiJava, DiVisualstudio, DiGit, DiJavascript1 } from "react-icons/di";
import {
  SiFirebase,
  SiNetlify,
  SiRedux,
  SiStyledcomponents,
  SiIntellijidea,
} from "react-icons/si";

export const skillData = [
  {
    icon: <FaHtml5 />,
    iconName: "HTML5",
  },
  {
    icon: <FaCss3 />,
    iconName: "CSS3",
  },
  {
    icon: <DiJavascript1 />,
    iconName: "JavaScript",
  },
  {
    icon: <FaSass />,
    iconName: "SCSS",
  },
  {
    icon: <FaReact />,
    iconName: "React",
  },
  {
    icon: <SiRedux />,
    iconName: "Redux",
  },
  {
    icon: <SiStyledcomponents />,
    iconName: "styled-components",
  },
  {
    icon: <FaGithub />,
    iconName: "Github",
  },
  {
    icon: <DiGit />,
    iconName: "Git Bash",
  },
  {
    icon: <DiVisualstudio />,
    iconName: "Visual Studio",
  },
  {
    icon: <SiNetlify />,
    iconName: "NetLify",
  },
  {
    icon: <SiFirebase />,
    iconName: "Firebase",
  },
];
